import { TotalesPorCuenta } from 'core/movimientos/models/TotalesPorCuenta';
import { Periodo } from 'shared/models/Periodo';
import { TablePlaceholder } from 'shared/placeholders';
import { Table } from 'shared/table';
import { TableComponentParams } from 'shared/table/hoc/withPagination';
import { formatCurrency } from 'shared/utils';

export interface TransactionSummaryByAccountTableProps
  extends TableComponentParams<TotalesPorCuenta> {
  periodo: Periodo;
}

export const TransactionSummaryByAccountTable = ({
  periodo,
  tableContent,
  placeholderRows,
  totales,
}: TransactionSummaryByAccountTableProps) => {
  return (
    <Table
      thead={
        <tr>
          <th>Cuenta</th>
          <th>Disponible inicial</th>
          <th>Transferencia Credito</th>
          <th>Transferencia Debito</th>
          <th>Acreditaciones</th>
          <th>Otros</th>
          <th>Extracciones</th>
          <th>Consumos</th>
          {periodo?.isCurrentPeriod() ? (
            <>
              <th>Movimientos Acumlados</th>
              <th>Disponible Actual</th>
            </>
          ) : (
            <th>Disponible Final</th>
          )}
        </tr>
      }
      tbody={
        <>
          {tableContent?.map((row) => (
            <tr
              key={`movimiento-agrupado-cuenta-${row.numeroCuenta}`}
              data-testid={`movimiento-agrupado-cuenta-${row.numeroCuenta}`}
            >
              <td className="align-middle">
                {`${row.denominacionCuenta} / ${row.numeroCuenta}`}
              </td>
              <td className="align-middle">{formatCurrency(row.saldoInicial)}</td>
              <td className="align-middle">{formatCurrency(row.transferenciaCredito)}</td>
              <td className="align-middle">{formatCurrency(row.transferenciaDebito)}</td>
              <td className="align-middle">{formatCurrency(row.creditosPesos)}</td>
              <td className="align-middle">{formatCurrency(row.otrosPesos)}</td>
              <td className="align-middle">{formatCurrency(row.adelantosPesos)}</td>
              <td className="align-middle">{formatCurrency(row.consumosPesos)}</td>
              <td className="align-middle">
                {formatCurrency(
                  row.saldoInicial +
                    row.transferenciaCredito +
                    row.transferenciaDebito +
                    row.creditosPesos +
                    row.otrosPesos +
                    row.adelantosPesos +
                    row.consumosPesos,
                )}
              </td>
              {periodo?.isCurrentPeriod() && (
                <td className="align-middle">{formatCurrency(row.saldoActual)}</td>
              )}
            </tr>
          )) || (
            <TablePlaceholder
              cols={periodo?.isCurrentPeriod() ? 10 : 9}
              rows={placeholderRows || 5}
            />
          )}
        </>
      }
      tfoot={
        <tr key="totales" data-testid="account-total">
          <td>Total</td>
          <td>{formatCurrency(totales?.saldoInicial)}</td>
          <td>{formatCurrency(totales?.transferenciaCredito)}</td>
          <td>{formatCurrency(totales?.transferenciaDebito)}</td>
          <td>{formatCurrency(totales?.creditosPesos)}</td>
          <td>{formatCurrency(totales?.otrosPesos)}</td>
          <td>{formatCurrency(totales?.adelantosPesos)}</td>
          <td>{formatCurrency(totales?.consumosPesos)}</td>
          <td>
            {formatCurrency(
              totales
                ? totales.saldoInicial +
                    totales.transferenciaCredito +
                    totales.transferenciaDebito +
                    totales.creditosPesos +
                    totales.otrosPesos +
                    totales.adelantosPesos +
                    totales.consumosPesos
                : 0,
            )}
          </td>
          {periodo?.isCurrentPeriod() && <td>{formatCurrency(totales?.saldoActual)}</td>}
        </tr>
      }
    />
  );
};
